export const SUPPORTED_DISPLAY_TYPE = [
    'text',
    'url',
    'uri',
    'file',
    'image',
    'select',
    'checkbox',
    'taxonomy',
    'date',
    'datetime',
    'email',
    'number',
    'title',
];
export const SUPPORTED_SORTABLE_TYPE = [
    'title',
    'number',
    'email',
    'date',
    'datetime',
    'text',
    'select',
    'checkbox',
    'taxonomy',
];
export const SUPPORTED_ELLIPSIS_TYPE = ['text', 'textarea', 'select', 'title'];
export const SUPPORTED_LABELIZE_TYPE = ['url', 'uri', 'file'];
export const SUPPORTED_DATE_FORMAT_TYPE = ['datetime', 'date'];
export const SUPPORTED_NUMBER_FORMAT_TYPE = ['number'];

export const SUPPORTED_MIMETYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
    'application/vnd.ms-excel',
];

export enum DATASOURCE_TYPE {
    DOC = 'doc',
    STUDIO = 'studio',
    CALC = 'calc',
    CALC_ATTACHMENT = 'calc-attachment',
}
